import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SecurityFooter from '@/components/feature/SecurityFooter';
import BrandLogo from '@/components/feature/BrandLogo';
import BrandPanel from './components/BrandPanel';
import LoginForm from './components/LoginForm';
import ForgotCodeModal from './components/ForgotCodeModal';
import { loginClient } from '@/hooks/useClientAuth';

export default function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);

  const handleSubmit = async (code: string) => {
    setSubmitting(true);
    setError(null);
    try {
      const result = await loginClient(code);
      if (result.ok) {
        navigate('/dashboard');
        return;
      }
      setSubmitting(false);
      if (result.reason === 'empty') setError(t('login.errorEmpty'));
      else if (result.reason === 'blocked') setError(t('login.errorBlocked'));
      else setError(t('login.errorInvalid'));
    } catch {
      setSubmitting(false);
      setError(t('login.errorInvalid'));
    }
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-background-50">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <img
          src="https://static.readdy.ai/image/7aa1f1eba25038b714c4ce0a30d01c7c/3fcf379ec5b26cb52367ff069cad5866.jpeg"
          alt=""
          className="h-full w-full object-cover object-center opacity-[0.28]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/45 via-background-50/70 to-background-50/95"></div>
      </div>

      <div className="relative z-10 grid flex-1 grid-cols-1 lg:grid-cols-2">
        <BrandPanel />

        <div className="flex flex-col">
          <div className="flex items-center gap-3 px-4 pt-6 lg:hidden md:px-6">
            <BrandLogo className="h-14" />
          </div>

          <div className="flex flex-1 items-center justify-center px-4 py-10 md:px-6 md:py-14">
            <LoginForm
              onSubmit={handleSubmit}
              error={error}
              submitting={submitting}
              onForgot={() => setForgotOpen(true)}
            />
          </div>
        </div>
      </div>

      <SecurityFooter />
      <ForgotCodeModal open={forgotOpen} onClose={() => setForgotOpen(false)} />
    </div>
  );
}